module.exports = __webpack_public_path__ + "static/assets/a9cb726293a94f63ffed85157b72a9b2.svg";